import useApiCall from "../../hooks/CancellableApiCall";
import {LoadingContent} from "../LoadingContent";
import React from "react";
import {ProfileResponse} from "../../data/ProfileResponse";
import {InternalAffairsLimitedComplaintResponse} from "../../data/internal-affairs/InternalAffairsLimitedComplaintResponse";
import {ComplaintTable} from "../internal-affairs/InternalAffairsComplaintMasterList";

interface EmployeeComplaintsProps {
    employee: ProfileResponse
    session?: string
}

interface EmployeeComplaintsContentProps {
    complaints: InternalAffairsLimitedComplaintResponse[] | null
}

function EmployeeComplaintsContent(props: EmployeeComplaintsContentProps) {
    return <ComplaintTable header={""} complaints={props.complaints} recordsView={true}/>
}

export const EmployeeComplaints = (props: EmployeeComplaintsProps) => {
    const sessionParam = props.session ? `?session=${props.session}` : ""
    const loadComplaints = useApiCall<InternalAffairsLimitedComplaintResponse[]>({
        url: `/api/records/complaints/${props.employee.communityId}${sessionParam}`
    })

    return (
        <LoadingContent isLoading={loadComplaints.isLoading}>
            <EmployeeComplaintsContent complaints={loadComplaints.data}/>
        </LoadingContent>
    )
}